import React from "react";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";

function Privacy() {
  return (
    <ContentLayoutFooterNoChartreuse title="Privacy">
      <div className="mx-10">
        <br />
        <h2 className="text-2xl">Privacy Policy</h2>
        <br />
        <h5>
          Raraity, Inc. (&quot;Raraity,&quot; &quot;we,&quot; or &quot;us&quot;) respects your privacy and is
          committed to protecting your personal data. This Privacy Policy
          applies to all personal data collected through the Raraity website
          (the &quot;Website&quot;) and any related services or products (collectively,
          the &quot;Services&quot;).
          <br />
          <br />
          This Privacy Policy describes the types of personal data we collect,
          how we use that data, and with whom we share it. It also describes
          your choices regarding our use of your personal data and how you can
          exercise those choices.
          <br />
          <br />
          Personal Data | We collect personal data that you provide to us when
          you use the Website or Services, such as your name, email address, and
          payment information. We may also collect information about your use of
          the Website or Services, such as your IP address and browser type.
          <br />
          <br />
          Use of Personal Data | We use your personal data to provide you with
          the Website and Services, including to process your transactions and
          communicate with you. We may also use your personal data to improve
          the Website and Services, to personalize your experience, and to
          analyze trends and usage.
          <br />
          <br />
          Sharing of Personal Data | We may share your personal data with
          third-party service providers who perform services on our behalf, such
          as payment processing and customer service. We may also share your
          personal data with law enforcement agencies or other government bodies
          as required by law or to protect our legal rights.
          <br />
          <br />
          International Transfers of Personal Data | Your personal data may be
          transferred to and processed in countries other than the country in
          which you reside. These countries may have data protection laws that
          are different from those in your country of residence.
          <br />
          <br />
          Security | We take reasonable measures to protect your personal data
          from unauthorized access, use, or disclosure. However, we cannot
          guarantee the security of your personal data transmitted to the
          Website or Services.
          <br />
          <br />
          Your Choices and Rights | You may have the right to access, correct,
          or delete your personal data. You may also have the right to object to
          or restrict our processing of your personal data. To exercise these
          rights, please contact us at privacy@raraity.com.
          <br />
          <br />
          Cookies and Other Technologies | We use cookies and other technologies
          to collect information about your use of the Website and Services. You
          can control cookies through your browser settings, but disabling
          cookies may limit your ability to use certain features of the Website
          or Services.
          <br />
          <br />
          Children | The Website and Services are not intended for use by
          children under the age of 13. We do not knowingly collect personal
          data from children under the age of 13.
          <br />
          <br />
          Changes to this Privacy Policy | We may update this Privacy Policy
          from time to time. We will notify you of any material changes to this
          Privacy Policy by posting a notice on the Website.
          <br />
          <br />
          Contact Us | If you have any questions or concerns about this Privacy
          Policy, please contact us at privacy@raraity.com.
        </h5>
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Privacy;

export async function getStaticProps() {
  return {
    props: { page: "Privacy" },
  };
}
